import { render, staticRenderFns } from "./Pix.vue?vue&type=template&id=1e353ecc&scoped=true&"
import script from "./Pix.vue?vue&type=script&lang=js&"
export * from "./Pix.vue?vue&type=script&lang=js&"
import style0 from "./Pix.vue?vue&type=style&index=0&id=1e353ecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e353ecc",
  null
  
)

export default component.exports